export default "__VITE_ASSET__BxCRPPMk__"